style= require('./feeds.styl')

.feeds
  if match
    ft-button.feed(
      (click)=toggleFeeds(match),
    )=match.stopFeeds ? 'Unlock feeds' : 'Lock feeds'
  if match && match.stopFeeds
    ft-button(
      warning,
      (click)=this.mergeFeeds(match)
    ) Use changes     